import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { apiAcceptance } from '../../api/apiAcceptance.api';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

export function ProviderTerms({ children }) {
  const { auth_token } = useSelector((state) => state.auth);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    if (!auth_token) return;
    acceptedAcceptances();
  }, [auth_token]);

  const acceptedAcceptances = async () => {
    let acceptance = [];

    const user_notification = localStorage.getItem('user_notification') === '1';
    const user_agreement = localStorage.getItem('user_agreement') === '1';
    const personal_data_processing_policy = localStorage.getItem('personal_data_processing_policy') === '1';

    if (user_notification) {
      acceptance.push('user_notification');
      localStorage.setItem('user_notification', 0);
    }
    if (user_agreement) {
      acceptance.push('user_agreement');
      localStorage.setItem('user_agreement', 0);
    }
    if (personal_data_processing_policy) {
      acceptance.push('personal_data_processing_policy');
      localStorage.setItem('personal_data_processing_policy', 0);
    }

    if (acceptance.length === 0) return;

    const items = await apiAcceptance.getAcceptancesDocuments(axiosPrivate).then((res) => res.items || []);
    const filteredItems = items.filter((i) => acceptance.includes(i.type));

    if (filteredItems.length === 0) return;

    Promise.all(filteredItems.map(async (i) => apiAcceptance.acceptAcceptance(axiosPrivate, i._id.toString())));
  };

  return children;
}
